import React from 'react';

/* Промо-блок на главной. Показывает 1-2 активные акции.
 * Скрывается, если активных акций нет. */
const PromoSection = ({ promotions = [], onOpenCart }) => {
    if (!promotions.length) return null;

    // Показываем максимум 2 акции
    const visible = promotions.slice(0, 2);

    return (
        <section className="py-8">
            <div className="grid md:grid-cols-2 gap-4">
                {visible.map((p, idx) => (
                    <div
                        key={p.id}
                        className="relative bg-gradient-to-br from-[#6B7A6A] to-[#4A5A4A] rounded-3xl p-6 md:p-8 text-white overflow-hidden shadow-xl"
                    >
                        {/* Декоративный круг */}
                        <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/5" />

                        <div className="relative">
                            <p className="text-xs uppercase tracking-[0.2em] opacity-80 mb-2">
                                Акция {idx === 0 ? 'сейчас' : 'дополнительно'}
                            </p>

                            <h3 className="serif text-2xl md:text-3xl mb-3">
                                {p.short_text}
                            </h3>

                            {p.type === 'cart_total' && (
                                <p className="text-sm opacity-90 mb-4">
                                    Добавьте товаров на сумму от {p.min_amount.toLocaleString('ru-RU')} ₽ —
                                    скидка применится в корзине автоматически.
                                </p>
                            )}
                            {p.type === 'cart_quantity' && (
                                <p className="text-sm opacity-90 mb-4">
                                    Соберите {p.min_quantity} разных товара в корзине —
                                    скидка применится в корзине автоматически.
                                </p>
                            )}
                            {['product', 'category', 'brand', 'custom'].includes(p.type) && (
                                <p className="text-sm opacity-90 mb-4">
                                    Скидка уже действует на карточках товаров — смотрите зачёркнутые цены.
                                </p>
                            )}

                            {p.ends_at && (
                                <p className="text-xs opacity-75 mb-4">
                                    ⏱ Действует до {p.ends_at.slice(0, 10)}
                                </p>
                            )}

                            <a
                                href="#catalog-section"
                                className="inline-block bg-white text-[#6B7A6A] px-5 py-2.5 rounded-full font-semibold text-sm hover:bg-gray-100 transition"
                            >
                                К покупкам →
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default PromoSection;